import AssetsComp from "../../Components/AssetsComp";

const AssetsPage = () => {

  return (
    <>
      <AssetsComp />
    </>
  );
};

export default AssetsPage;
